import { z } from "zod";

const PAGE_SIZE = 10;

/** The list's sortable columns (the story's Sort list), by column id; the
 *  screen maps each to the API's `sortBy` in the screen's language. */
export const GPRS_SORT_COLUMNS = [
  "company",
  "deviceName",
  "imei",
  "command",
  "executionTime",
  "status",
  "createdAt",
] as const;

export type GprsSortColumn = (typeof GPRS_SORT_COLUMNS)[number];

export const gprsCommandsSearchSchema = z
  .object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(PAGE_SIZE),
    sortBy: z.enum(GPRS_SORT_COLUMNS).optional(),
    sort: z.enum(["asc", "desc"]).optional(),
    // No `.trim()` -- the search input is controlled by router state, so
    // trimming on parse would strip a trailing space the instant it's typed.
    search: z.string().min(1).optional(),
    status: z.enum(["PENDING", "SUCCESSFUL", "FAILED", "TIMED_OUT"]).optional(),
    createdFrom: z.string().datetime().optional(),
    createdTo: z.string().datetime().optional(),
  })
  .refine(
    (search) =>
      (search.createdFrom === undefined) === (search.createdTo === undefined),
  );

export type GprsCommandsSearch = z.infer<typeof gprsCommandsSearchSchema>;
